// @flow
import React, {Component} from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './SelectFormInput.css';
import _ from 'lodash/fp';

export type Props = {
  input: any,
  label?: string,
  placeholder?: string,
  disabled?: boolean,
  meta: any,
  options: any[],
  multi?: boolean,
  labelKey: string,
  valueKey: string,
  isLoading?: boolean,
  clearable?: boolean,
  keepOpen?: boolean,
};

export type State = {
  selectRef?: any,
};

class SelectFormInput extends Component<Props, State> {
  static defaultProps = {
    isLoading: false,
    clearable: false,
    keepOpen: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      selectRef: null,
    };
  }

  onGetSelectRef = (ref: any) => {
    this.setState({
      ...this.state,
      selectRef: ref,
    });
  }

  keepSelectOpen = () => {
    if (this.props.keepOpen && this.state.selectRef) {
      this.state.selectRef.setState({isOpen: true});
    }
  }

  render() {
    const {
      input,
      label = '',
      placeholder,
      disabled = false,
      meta: {touched, error},
      options,
      labelKey,
      valueKey,
      multi,
      isLoading = false,
      clearable = false,
    } = this.props;

    return (
      <div>
        {label &&
          <label className={classNames({'is-invalid-label': touched && error})}>
            {label}
          </label>
        }
        <div>
          <Select
            ref={this.onGetSelectRef}
            value={input.value}
            onChange={value => {
              this.keepSelectOpen();
              input.onChange(!_.isEmpty(value) ? value : multi ? [] : null);
            }}
            options={options}
            placeholder={placeholder || label}
            clearable={clearable}
            labelKey={labelKey}
            valueKey={valueKey}
            isLoading={isLoading}
            disabled={!!disabled}
            valueRenderer={option => {
              if (!option[labelKey] && !(options && options.length)) {
                return 'Laddar...';
              } else if (!option[labelKey]) {
                return (_.find({[valueKey]: option[valueKey]}, options) || {})[labelKey];
              } else {
                return option[labelKey];
              }
            }}
            className={classNames({'is-invalid-input': touched && error})}
            multi={multi || false}
            noResultsText="Inga resultat hittades"/>
          {touched && error &&
            <span className="form-error is-visible">{error}</span>
          }
        </div>
      </div>
    );
  }
}

export default SelectFormInput;



// WEBPACK FOOTER //
// ./src/components/SelectFormInput/SelectFormInput.js